module.exports = __webpack_public_path__ + "static/ic_draw_s.ea9220c0.png";